const MenuBarStyle = {
    fontFamily: 'Roboto, "Helvetica Neue", "Sukhumvit Set", Kanit, Avenir, -apple-system, BlinkMacSystemFont, "Segoe UI", Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", sans-serif',
    fontDisplay: "swap",
    fontWeight: "bold",
    fontSize: "1.25em"
  }
  
  export default MenuBarStyle;